import { useRef, useEffect } from 'react';
import { Annotation } from '../../../types/annotation';

interface TimelineMinimapProps {
  duration: number;
  currentTime: number;
  streamStart: Date;
  annotations: Annotation[];
  height?: number;
}

export function TimelineMinimap({
  duration,
  currentTime,
  streamStart,
  annotations,
  height = 24
}: TimelineMinimapProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw annotations
    annotations.forEach(annotation => {
      const x = ((annotation.startTime.getTime() - streamStart.getTime()) / 1000 * duration) * canvas.width;
      const width = ((annotation.endTime.getTime() - annotation.startTime.getTime()) / 1000 * duration) * canvas.width;
      
      ctx.fillStyle = annotation.color;
      ctx.fillRect(x, 0, width, height);
    });

    // Draw playhead
    const playheadX = (currentTime / duration) * canvas.width;
    ctx.fillStyle = '#3b82f6';
    ctx.fillRect(playheadX - 1, 0, 2, height);
  }, [annotations, currentTime, duration, height]);

  return (
    <canvas
      ref={canvasRef}
      width={1000}
      height={height}
      className="tw-w-full tw-h-full"
    />
  );
}